module.exports = __webpack_public_path__ + "img/numCard-11_En.44899887.svg";